import { styled } from "@mui/material/styles";
import { TalkingHead } from "components/talking-head";

export const Infobox = styled(TalkingHead, { label: "infobox" })`
  margin-left: ${({ theme }) => theme.spacing(1)};
`;
